import type { CSSObject } from '@emotion/react';

const allTextMarginBottom = 12;

export const tiptapDefaultStyle: CSSObject = {
  '.tiptap': {
    '&.ProseMirror': {
      width: '100%',

      '&.ProseMirror-focused': {
        outlineWidth: 0,
        outlineColor: 'transparent',
        outlineStyle: 'none',
      },
      'p, h1, h2, h3, h4, h5, h6': {
        marginBottom: allTextMarginBottom,
        ':only-child': {
          marginBottom: 0,
        },
        "span[data-spotstyle='customBold']": {
          fontWeight: 'normal',
        },
        "span[data-spotstyle='customItalic']": {
          fontStyle: 'normal',
        },
        "span[data-spotstyle='customUnderline']": {
          display: 'inline-block',
          textDecoration: 'none',
        },
      },
    },
    mark: {
      padding: '0.1rem 0.3rem',
    },
  },
  '.editable-cell-wrapper': {
    '.tiptap': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
      '> div': {
        marginBottom: allTextMarginBottom,
      },
    },
  },
  '.edit-state': {
    '.py-editor-table-style, .py-preview-table-style': {
      '.py-total-row, .py-subtotal-row': {
        '.py-footer-cell:focus-within .py-tableContextMenuTrigger, .py-footer-cell:hover .py-tableContextMenuTrigger': {
          visibility: 'visible',
          opacity: '1',
          zIndex: 100,
        },
      },
    },
  },
  '.py-editor-table-style, .py-preview-table-style': {
    'div:has(.py-column-selected) .py-tableContextMenuTrigger': {
      visibility: 'visible',
      opacity: '1',
    },
    '.py-tableContextMenuTrigger': {
      visibility: 'hidden',
      opacity: '0',
      transition: 'all 200ms ease-in-out',
    },
    '.py-total-row': {
      backgroundColor: 'var(--table-row-default-background-color)',
      '.tiptap': {
        textAlign: 'right',
      },
    },
    '.py-subtotal-row': {
      backgroundColor: 'var(--table-row-default-background-color)',
    },
  },
  '.editor__page__draggable .py-darkGrey-row': {
    background: '#EFEFEF',
  },
  '.editor__page:has(.edit-state)': {
    '.block-type-table:not(.edit-state) .selected-row, .block-type-table:not(.edit-state) .unselected-row': {
      '&:hover::before': {
        backgroundColor: 'transparent',
      },
      '&:hover::after': {
        backgroundColor: 'rgba(224, 229, 231, 1)',
      },
    },
  },
};
